import React from "react";
import img from "../../assets/pediatricians/sec2.png";
import patt from "../../assets/Home/model-patt.png";
import PinkBtn from "../../Components/PinkBtn";
function Section2() {
  return (
    <div className="w-full flex justify-center items-center mt-[140px] xl:mt-[220px] px-5">
      <div className="xl:flex-row flex-col max-w-[1440px] flex justify-center items-center gap-10 xl:gap-8 w-full">
        <div className="flex justify-center items-start flex-col mr-2 gap-4 xl:w-1/2">
          <h1 className="text-lightGreen-500 leading-9 sm:leading-[50px] font-bold text-[30px] sm:text-[48px]  ">
            Early Intervention Makes A <br /> Big Difference
          </h1>
          <p className="text-lightGreen-500 font-normal text-lg ">
            Research indicates that early diagnosis of and intervention for
            autism are more likely to have major long term positive effects on
            symptoms and later skills.
          </p>
          <div className="mt-6">
            <PinkBtn text={"Refer a Patient"} url={"ReferalForm"} target="_blank" />
          </div>
        </div>
        <div className="relative isolate  flex justify-end items-center">
          <img
            src={patt}
            className="absolute -z-[1] -top-[10%] sm:-left-[8%] h-full -left-[4%]"
            alt=""
          />
          <img
            src={img}
            alt=""
            className="w-full max-w-[400px] xl:max-w-[522px]"
          />
        </div>
      </div>
    </div>
  );
}

export default Section2;
